import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Login16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M8.00006 2.06065L4.53039 5.53032L3.46973 4.46966L7.11617 0.823209C7.60433 0.335053 8.39579 0.335054 8.88394 0.823209L15.1768 7.1161C15.665 7.60426 15.665 8.39571 15.1768 8.88387L8.88394 15.1768C8.39578 15.6649 7.60433 15.6649 7.11617 15.1768L3.46973 11.5303L4.53039 10.4697L8.00006 13.9393L13.9394 7.99999L8.00006 2.06065Z'
      fill='currentColor'
    />
    <path
      d='M7.68939 8.75H1V7.25H7.6894L6.46973 6.03033L7.53039 4.96967L10.5607 8L7.53039 11.0303L6.46973 9.96967L7.68939 8.75Z'
      fill='currentColor'
    />
  </Svg>
);

Login16.displayName = 'Login16';
export default Login16;
